import { reactive } from "vue";

/**
 * Shared, session-only state for the typed-measurement keypad — lets the
 * toggle button (Polyline/Line/Ellipse/Rectangle option menus) and the keypad
 * panel itself (sibling components) agree on open/closed state and dragged
 * screen position without prop drilling. Intentionally never persisted to
 * CanvasSettingsState/local storage: it's fine to lose both once the
 * drawing is closed or the app reloads.
 */
type MeasurementKeypadState = {
  isOpen: boolean;
  position: { x: number; y: number };
  /**
   * Last mode the user picked in the pad (see relativePointInput.ts). Sticky
   * across steps and tools so switching to L/angle once doesn't have to be
   * redone on every vertex. Steps that don't offer it fall back to their own
   * first mode WITHOUT overwriting this, so the preference survives a detour
   * through ROTATE or SCALE.
   */
  modeId: string;
};

export default reactive<MeasurementKeypadState>({
  isOpen: false,
  position: { x: 0, y: 0 },
  modeId: "xy",
});
